import type { UserAlertsDto } from "@intelligems/ig-types/dtos/users";
import { useUser } from "@src/api/user-auths/login";
import { setUserAlerts } from "@src/api/users/user-alerts";

/**
 * A one-time notice for the logged-in user, shown until they dismiss it, on
 * any device. A key the user has never had shows.
 */
export const useUserAlert = (key: keyof UserAlertsDto) => {
  const user = useUser();
  const loggedIn = user.data?.type === "login" ? user.data.user : null;

  return {
    show: loggedIn !== null && loggedIn.userAlerts?.[key] !== false,
    dismiss: () => setUserAlerts({ [key]: false }),
  };
};
